export default "__VITE_ASSET__8993bca5__"